import './AppContainer.scss';

import React from 'react';

// keep this import as it helps with decorating focus boxes when mouse, touch or keyboard "data-whatintent"
import whatInput from 'what-input'; // eslint-disable-line

import { Router } from '@ulta/core/components/Router/Router';
import ContextContainer from '@ulta/core/containers/ContextContainer/ContextContainer';
import { AppConfigProvider } from '@ulta/core/providers/AppConfigProvider/AppConfigProvider';

function AppContainer( props ){
  const { appConfig, inflection, children, client, context = {}, locale, href, searchParams, pathname, helmetContext } = props;

  return (
    <AppConfigProvider context={ appConfig }>
      <div className={ APP_CONTAINER_CLASS }>
        <ContextContainer
          inflection={ inflection }
          client={ client }
          searchParams={ searchParams }
          context={ context }
          locale={ locale }
          helmetContext={ helmetContext }
        >
          <Router
            href={ pathname }
          >
            { children && React.cloneElement( children, { searchParams, href, pathname } ) }
          </Router>
        </ContextContainer>
      </div>
    </AppConfigProvider>
  );
}

/**
 * @const {string} APP_CONTAINER_CLASS - class name for the AppContainer
 */
export const APP_CONTAINER_CLASS = 'AppContainer';

export default AppContainer;
